import React, { useEffect, useState } from 'react'
import { Input, Button, Modal, Spin, Row, Select,Drawer } from 'antd'
import { withDomains, RESTExecutor } from "../../lib/domain";
import Form from '../../lib/ui/form';
import { schema_to_field, showErrorInNotification } from '../../lib/util';
import Title from 'antd/lib/typography/Title';

const ConfigRefill = (props) => {
    const [visible, setVisible] = useState(false)
    const [isLoading, setIsLoading] = useState(true);
    const [configData, setConfigData] = useState({});
    const [parsersObj,setParserObj]=useState({})
    const [parserSchema,setParserSchema]=useState([]);


    const listParsersExecutor = RESTExecutor.list().config({
        label: 'parsers'
      }).callbacks((success) => {
        let parsers = {};
        success.result.rows.map((item) => {
          parsers[item.id] = item
        });
        setParserObj(parsers)
        
        if (configData.parser_id) {
            setParserSchema(schema_to_field(parsersObj[configData.parser_id]?.validation_config || {}))
        }
      }, (error) => {
        showErrorInNotification(error);
      }).connect(props.domains.plugins)

    const atm_refill_config = RESTExecutor.list()
        .config({
            label: "atm_refill_config",
        })
        .callbacks(
            (success) => {
                console.log(success)
                let rowsData = success.result || [];
                let filteredData = JSON.parse(JSON.stringify(rowsData));
                console.log("ConfigData:", filteredData)
                setConfigData(filteredData)
                setIsLoading(false)
                listParsersExecutor.execute();
            },
            (error) => {
                console.log(error);
            }
        )
        .connect(props.domains.activity);

    const atm_refill_edit = RESTExecutor.post().config({
        label: "atm_refill_config"
    }).callbacks((success)=>{ setVisible(false);},(error)=>{
        showErrorInNotification(error);
    }).connect(props.domains.activity)

    useEffect(() => {
        // atm_refill_config.execute()
        // setinitialData(testData)
    }, [])

   

    const showModal = () => {
        setVisible(true);
        atm_refill_config.execute();
    }

    const handleOk = () => {
        // event.preventDefault();
        console.log(configData);
        atm_refill_edit.execute(configData)
    }

    const handleCancel = () => {
        setVisible(false);
        setConfigData({});
        setParserSchema([]);
    }

    const addEditReponse=atm_refill_edit.response();
    const listParsersResponse=listParsersExecutor.response();
    return (
        <div><Button type="default" onClick={showModal}><strong>Config</strong></Button>
            <Drawer
            title="Refill Table Config"
            placement="right"
            closable={false}
            width='50%'
            destroyOnClose
            onClose={handleCancel}
            visible={visible}
            >
                 {isLoading ? (<Spin />) : (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap:'16px'
                      }}>
                    <Form
                    forCreate={true}
                    initialData={configData}
                    parentData={configData}
                    submitted={false}
                    onChange={(data) => {
                        setConfigData(data);
                    //   this.setState({ form_data: data });
                    }}
                    fields={[
                        {
                            name:"EJ Flag",
                            index:"ej_flag",
                            type:"number"
                        },
                        {
                            name:"Ledger Flag",
                            index:"ledger_flag",
                            type:"number"
                        },
                        {
                            name:"EJ Data Type ID",
                            index:"ej_data_type_id",
                            type:"number"
                        },
                        {
                            name:"Ledger Data Type ID",
                            index:"ledger_data_type_id",
                            type:"number"
                        },
                        {
                            name:"Reconciler ID",
                            index:"reconciler_id",
                            type:"number"
                        },
                        {
                            name:"Ledger Refill Pattern",
                            index:"ledger_refill_pattern",
                            type:"text"
                        },
                        {
                            name:"EJ CB Pattern",
                            index:"ej_cb_pattern",
                            type:"text"
                        },
                        {
                            name:"Ledger CB",
                            index:"ledger_cb_col",
                            type:"text"
                        },
                        {
                            name:"Trace No",
                            index:"trace_no_col",
                            type:"text"
                        },
                        {
                            name:"EJ Refill",
                            index:"ej_refill_col",
                            type:"text"
                        },
                        {
                            name:"Marked",
                            index:"marked_col",
                            type:"text"
                        }
                    ]}
                    errorMessage={addEditReponse.error_message}
                    validationErrors={addEditReponse.validation_errors}
                    />
                    
                    <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4
          }}>
              <div></div>
              <span>Parser:</span>
              <Select
                placeholder={"Parser"}
                value={configData.parser_id}
                showSearch
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                loading={listParsersResponse.fetching}
                onChange={(value) => {
                  console.log("parser id", value, parsersObj[value]);
                  setConfigData({
                    ...configData,
                    parser_id:value
                  })
                  setParserSchema(schema_to_field(parsersObj[value].validation_config))

                //   this.stateUpdater({ stateKey: 'form_data', valueKey: 'parser_id', value: value })
                //   this.setState({
                //     parserSchema: schema_to_field(parsersObj[value].validation_config),
                //     blocks_schema: schema_to_field(this.state.parsers[value].blocks_config),
                //   })
                }}
              >
                {Object.keys(parsersObj).map((key) => {

                  let dataItem = parsersObj[key] || {}
                  return <Select.Option value={dataItem.id} key={dataItem.id}>
                    {dataItem.name}
                  </Select.Option>
                })}
              </Select>

            </div>

          {configData.parser_id ?
            <div style={{
              marginTop:10
            }}>
              <div>
                <Row style={{
                  padding: 4
                }} type='flex'
                  justify='space-between'>
                  <Title style={{ margin: 0 }} level={4} type='secondary'>Parser Configs</Title>

                  {/* <Button size='small' type='primary' className='export-btn' onClick={() => {
                    copyStringToClipboard(JSON.stringify(form_data.parse_config || {}));
                    message.success("Copied")
                  }}>Copy To Clipboard</Button> */}
                </Row>
                <Form
                  hideTitle
                  forCreate={true}
                  initialData={configData.parser_config || {}}
                  submitted={false}
                  onChange={(data) => {
                    console.log("Changes", data);
                    setConfigData({
                        ...configData,
                        'parser_config':data
                    })
                  }}
                  fields={parserSchema}
                  submitting={{}}
                  errorMessage={{}}
                  validationErrors={{}}
                />
              </div>
            </div>
            : null}

<br></br>
          <br></br>
          <Row type='flex' justify='space-between'>
            <div>
              <Button type='link' style={{ color: 'red' }} onClick={() => {
                handleCancel();
              }}>Cancel</Button>
            </div>
            <div>
              <Button type='primary' 
              loading={addEditReponse.fetching}
              disabled={addEditReponse.fetching}
              onClick={() => {
                handleOk()
              }}>Submit</Button>
            </div>
          </Row>

                    </div>
                )}

            </Drawer>
            {/* <Modal
                title={""}
                closable={false}
                style={{ top: "20px" }}
                visible={visible}
                onOk={handleOk}
                okText={"Submit"}
                onCancel={handleCancel}
            > */}
               
            {/* </Modal> */}
            </div>
    )
}

export default withDomains(ConfigRefill, "activity","plugins")